<template>
  <row class="home-sect flex no-pad">
    <home-sect-image v-if="isLeft" :index="index" :image="image"/>
    <column :md="8" :lg="6">
      <div class="content">
        <h3>
          {{ title }}
        </h3>
        <div class="text">
          <p>
            {{ text }}
          </p>
        </div>
      </div>
    </column>
    <home-sect-image v-if="!isLeft" :index="index" :image="image"/>
  </row>
</template>

<script>
import HomeSectImage from './HomeSectImage'
import { getters } from '../utils'

export default {
  components: { HomeSectImage },
  props: ['image', 'index', 'tag', 'text', 'title'],
  computed: {
    isLeft() {
      return this.index % 2 || !this.screenSizes.includes('lg')
    },
    ...getters('screenSizes'),
  },
}
</script>

<style lang="scss">
@import '~style/variables';

.home-sect {
  color: $c-text;
  min-height: 350px;
  .content {
    margin: 0 auto;
    max-width: 90%;
    padding-top: 2rem;
    @media screen and (max-width: $res-md) {
      padding-bottom: 1rem;
    }
    @media screen and (min-width: $res-md) {
      max-width: 80%;
    }
    @media screen and (min-width: $res-lg) {
      padding-top: 2rem;
      max-width: 70%;
    }
    @media screen and (min-width: $res-xl) {
      padding-top: 3rem;
      max-width: 64%;
    }
    @media screen and (min-width: $res-xxl) {
      padding-top: 4rem;
      max-width: 57%;
    }
  }
  // .htag {
  //   font-size: 0.8125rem; // 13px
  //   font-weight: $semibold;
  //   margin-bottom: 2rem;
  //   &:before, &:after {
  //     content: ' ';
  //     border-color: $c-main;
  //     border-style: solid;
  //     border-width: 1px 0 1px 1px;
  //     padding: 0.75rem 0.5rem;
  //   }
  //   &:after {
  //     border-width: 1px 1px 1px 0;
  //   }

  //   // themes
  //   &.danger {
  //     &:before, &:after {
  //       border-color: $c-danger;
  //     }
  //   }
  //   &.success {
  //     &:before, &:after {
  //       border-color: $c-success;
  //     }
  //   }
  // }
  h3 {
    font-size: 2.6875rem; // 43px
    font-weight: $bold;
    line-height: 3rem;
    margin-bottom: 2rem;
  }
  .text {
    font-size: 1.125rem; // 18px
    font-weight: $medium;
    p {
      letter-spacing: 0.5px;
      line-height: 1.75rem;
      margin: 1rem 0;
    }
  }
  @media screen and (min-width: $res-md) {
    &.first {
      .home-sect-image::before {
        border-top: 3rem solid #fff;
        border-left: 3rem solid rgba(0,0,0,0.2);
        right: 0;
        top: 0;
      }
    }
    &.last {
      .home-sect-image::before {
        bottom: 0;
        border-bottom: 3rem solid #fff;
        border-right: 3rem solid rgba(0,0,0,0.2);
        left: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/HomeSect.vue